import axios from "../../common/utils/axios";

class ApiHelper {

    constructor(url) {
        this.url = url;
    }

    static buildInlineParams(data) {
        if (Object.entries(data).length == 0) return "";
        var params = "?";
        var index = 0;
        for (const [key, value] of Object.entries(data)) {
            params += key + "=" + value
            if (index < Object.entries(data).length - 1)
                params += "&&";
            index++;
        }
        return params;
    }

    async get(data) {

        var inUrlParams = (data != undefined) ? this.buildInlineParams(data) : '';
        return axios({ url: this.url + inUrlParams, method: "GET" })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }


    async getDetailed(data) {
        var inUrlParams = (data != undefined) ? this.buildInlineParams(data) : '';
        return axios({ url: this.url + "/details" + inUrlParams, method: "GET" })
            .then(resp => {
                return resp.data
            })
            .catch(err => {

            });
    }

    async all(data) {
        return axios({ url: this.url, data: data, method: "GET" })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }

    async create(data, params) {
        return axios({ url: this.url, data: data, method: "POST", notification: true, authorization: params.authorization, showLoader: params.loader, message: params.message })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }

    async edit(data) {
        return axios({ url: this.url, data: data, method: "PUT", notification: true, showLoader: true })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }

    async delete1(id) {
        return axios({ url: this.url, method: "DELETE", data: { id: id }, notification: true, authorization: true, showLoader: true })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }

    async delete(id) {
        return axios({ url: this.url + "/" + id, method: "DELETE", notification: true, authorization: true, showLoader: true })
            .then(resp => {
                return resp.data
            })
            .catch(err => {
                resolve(err)
            });
    }

    async findById(id) {
        return axios({ url: this.url + "/" + id, method: "GET", showLoader: true })
            .then(resp => {
                return resp.data
            })
            .catch(err => {});
    }

}

export default ApiHelper;